import type { QueryClient } from '@tanstack/vue-query'

const pending = new WeakMap<QueryClient, Map<string, Promise<void>>>()
/** Merge REST and socket refreshes. Let earlier reads finish, then fetch fresh data. */
export function refreshEpisodeQueries(client: QueryClient, queryKey: string[]): Promise<void> {
  let requests = pending.get(client)
  if (!requests) { requests = new Map(); pending.set(client, requests) }
  const id = JSON.stringify(queryKey)
  const existing = requests.get(id)
  if (existing) return existing
  const refresh = new Promise<void>(resolve => setTimeout(resolve, 150)).then(async () => {
    const reads = client.getQueryCache().findAll({ queryKey })
      .filter(query => query.state.fetchStatus === 'fetching').map(query => query.promise)
    await Promise.allSettled(reads)
    // New invalidations during this fetch queue one follow-up rather than cancelling it.
    requests!.delete(id)
    await client.invalidateQueries({ queryKey }, { cancelRefetch: false })
  })
  requests.set(id, refresh)
  return refresh
}
